import { render, staticRenderFns } from "./Clientes.vue?vue&type=template&id=40956eae"
import script from "./Clientes.vue?vue&type=script&lang=js"
export * from "./Clientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40956eae')) {
      api.createRecord('40956eae', component.options)
    } else {
      api.reload('40956eae', component.options)
    }
    module.hot.accept("./Clientes.vue?vue&type=template&id=40956eae", function () {
      api.rerender('40956eae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/users/Clientes.vue"
export default component.exports